module.exports = __webpack_public_path__ + "img/intro2_zh.55fc457e.jpg";